/* custom-navigation.js */
/* Exact mobile/desktop structure renderer, optimized and vanilla JS */

(function () {
  const DESKTOP_MIN = 1025;
  const ROOT_SELECTOR = '.js-custom-nav-root';
  const DESKTOP_LAYER_CLASS = 'js-desktop-menu-overlay';
  let currentMode = null;
  let desktopCloseTimer = null;
  let desktopOverlayHydrated = false;

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Keep decorative moon/star symbols out of navigation labels and standardize BNPL wording.
  function formatNavTitle(title, href = '') {
    const rawTitle = String(title ?? '');
    if (String(href || '').includes('/pages/buy-now-pay-later') || /buy\s*now\s*pay\s*later/i.test(rawTitle)) {
      return 'Buy Now, Pay Later';
    }
    return rawTitle
      .replace(/[☽☾✦✧★☆⭐🌟🌙🌛🌜✨]/gu, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  /** When a mobile submenu opens, prioritize its images so bandwidth is not dominated by the first category only. */
  function bumpMobileMenuImages(root) {
    if (!root) return;
    qsa('img[src]', root).forEach(img => {
      try {
        img.fetchPriority = 'high';
      } catch (_) {}
      if (img.loading === 'lazy' && !img.complete) img.loading = 'eager';
    });
  }

  function optimizeImageUrl(url, width = 320) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      // Avoid hard-forced WebP so older iOS Safari can negotiate supported formats.
      parsed.searchParams.delete('format');
      if (!parsed.searchParams.has('width')) {
        parsed.searchParams.set('width', String(width));
      }
      return parsed.toString();
    } catch (_) {
      return url;
    }
  }

  function getData() {
    return window.CUSTOM_NAVIGATION_DATA || { topNav: [], mobileMenu: { items: [], bottomLinks: [] } };
  }

  function getMode() {
    return window.innerWidth >= DESKTOP_MIN ? 'desktop' : 'mobile';
  }

  function ensureBodyLayer(className) {
    let el = document.querySelector('.' + className);
    if (!el) {
      el = document.createElement('div');
      el.className = className;
      document.body.appendChild(el);
    }
    return el;
  }

  function renderTopNav(items) {
    return `
      <ul class="navbar-nav main-categories desktop-menu">
        ${items.map(item => `
          <li class="nav-item" data-uid="${escapeHtml(item.uid)}">
            <a
  href="${escapeHtml(item.href)}"
  class="nav-link${String(item.href || '').includes('/pages/buy-now-pay-later') ? ' buy-now-pay-later-nav-link' : ''}"
  title="${escapeHtml(formatNavTitle(item.title, item.href))}"
>
              <span class="nav-link-text">${escapeHtml(formatNavTitle(item.title, item.href))}</span>
            </a>
          </li>
        `).join('')}
      </ul>
    `;
  }

  function renderDesktopOverlay(items) {
    return `
      <div class="nav-bar-open">
        <div class="nav-container">
          <div class="content-wrapper">
            <div class="nav-type-wrapper">
              <ul class="type-box">
                ${items.map((item, index) => `
                  <li class="type-item${index === 0 ? ' active' : ''}" data-uid="${escapeHtml(item.uid)}">
                    <div class="type-link">
                      <span class="type-name">
                        <a
  href="${escapeHtml(item.href)}"
>
  ${escapeHtml(formatNavTitle(item.title, item.href))}
</a>
                      </span>
                    </div>
                  </li>
                `).join('')}
              </ul>
            </div>

            <div class="nav-product-wrapper">
              <div class="product-box">
                ${items.map((item, itemIndex) => {
                  const hasCategoryNav = item.groups.some(group => String(group.title || '').trim() !== '');
                  const allProducts = item.groups.reduce((acc, group) => acc.concat(group.products || []), []);
                  const normalizedGroups = hasCategoryNav
                    ? [{ id: '__all__', products: allProducts }].concat(item.groups)
                    : [{ id: 'all-products', products: allProducts }];

                  return `
                    <div class="type1${itemIndex === 0 ? ' active' : ''}" data-uid="${escapeHtml(item.uid)}">
                      ${hasCategoryNav ? `
                        <div class="cateNav">
                          ${item.groups.map((group, groupIndex) => `
                            <div class="cateNavItem" data-id="${escapeHtml(group.id)}">
                              <a href="${escapeHtml(group.href || item.href)}">${escapeHtml(group.title)}</a>
                            </div>
                          `).join('')}
                        </div>
                      ` : ''}

                      <div class="product-list">
                        ${normalizedGroups.map((group, groupIndex) => `
                          <div class="product-series${groupIndex === 0 ? ' active' : ''}" data-id="${escapeHtml(group.id)}">
                            <div class="product-wrapper">
                              ${[...(group.products || [])]
  .sort((a, b) => {
  const orderA = Number.isFinite(+a.displayOrder) ? +a.displayOrder : Infinity;
  const orderB = Number.isFinite(+b.displayOrder) ? +b.displayOrder : Infinity;

  if (orderA !== orderB) {
    return orderA - orderB;
  }

  return Number(b.isNew) - Number(a.isNew);
})
  .map(product => `
                                <div class="product-item">
                                  <a href="${escapeHtml(product.href)}">
                                    <div class="product-img product-img-1">
                                      ${product.image ? `<img src="${escapeHtml(optimizeImageUrl(product.image, 320))}" alt="${escapeHtml(product.name)}" loading="lazy" decoding="async" fetchpriority="low">` : ''}
                                      <div class="tags">
                                        ${product.isNew ? '<span class="tag new"> NEW </span>' : ''}
                                      </div>
                                    </div>

                                    <p class="product-name">
                                      <span class="product-name-text">
                                        ${escapeHtml(
                                          product.name === "A50CS"
                                            ? "A50C"
                                            : product.name === "A100CS"
                                            ? "A100C"
                                            : product.name
                                        )}
                                      </span>

                                      ${
                                        product.name === "A50CS" || product.name === "A100CS"
                                          ? `
                                            <img
                                              src="https://cdn.shopify.com/s/files/1/0870/8469/5851/files/logo.png?v=1782827193"
                                              alt="Special Edition"
                                              class="special-edition-logo"
                                            />
                                          `
                                          : ""
                                      }
                                    </p>
                                  </a>
                                </div>

                              `).join('')}
                            </div>
                          </div>
                        `).join('')}
                      </div>
                    </div>
                  `;
                }).join('')}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function renderMobileTopLinks(links) {
  if (!links?.length) return '';

  return `
    <div class="mobile-menu-top-links">
      ${links.map((link, index) => {
        const isHighlight = !!link.highlight;
        const titleLower = String(link.title || '').toLowerCase();
        const isBuyNowPayLater = String(link.href || '').includes('/pages/buy-now-pay-later') || titleLower.includes('buy now pay later');
        const isIndependence = isHighlight && !isBuyNowPayLater && (index === 0 || titleLower.includes('independence'));
        const isSummerSale = isHighlight && !isBuyNowPayLater && !isIndependence && (index === 1 || titleLower.includes('super summer'));
        const linkClass = [
          isHighlight ? 'highlight-nav-link' : '',
          isIndependence ? 'independence-sale-nav-link' : '',
          isSummerSale ? 'summer-sale-nav-link' : '',
          isBuyNowPayLater ? 'buy-now-pay-later-nav-link' : ''
        ].filter(Boolean).join(' ');
        const inlineStyle = isIndependence
          ? `color: ${link.textColor || '#ffffff'} !important; -webkit-text-fill-color: ${link.textColor || '#ffffff'} !important;`
          : isSummerSale
            ? `color: ${link.textColor || '#ffffff'} !important; -webkit-text-fill-color: ${link.textColor || '#ffffff'} !important;`
            : isHighlight
              ? `background: ${link.backgroundColor || '#CC0000'} !important; color: ${link.textColor || '#ffffff'} !important; -webkit-text-fill-color: ${link.textColor || '#ffffff'} !important;`
              : 'color: #000000 !important; -webkit-text-fill-color: #000000 !important;';

        if (isBuyNowPayLater) {
          return `
        <a
          href="${escapeHtml(link.href)}"
          class="${linkClass}"
          style="color: #ffffff !important; -webkit-text-fill-color: #ffffff !important;"
        >
          <span class="buy-now-pay-later-shine" aria-hidden="true"></span>
          <span class="buy-now-pay-later-label">${escapeHtml(formatNavTitle(link.title, link.href))}</span>
        </a>
      `;
        }

        if (isIndependence) {
          return `
        <a
          href="${escapeHtml(link.href)}"
          class="${linkClass}"
          style="${inlineStyle}"
        >
          <span class="independence-sale-pill-bg" aria-hidden="true"></span>
          <span class="independence-sale-pill-label">${escapeHtml(formatNavTitle(link.title, link.href))}</span>
        </a>
      `;
        }

        return `
        <a
          href="${escapeHtml(link.href)}"
          class="${linkClass}"
          style="${inlineStyle}"
        >
          ${isSummerSale ? '<span class="summer-sale-pill-bg" aria-hidden="true"></span><span class="summer-sale-pill-label">' : ''}
          ${escapeHtml(formatNavTitle(link.title, link.href))}
          ${isSummerSale ? '</span>' : ''}
        </a>
      `;
      }).join('')}
    </div>
  `;
}

  function renderMobileMenu(menu) {
    const topLinks = menu.topLinks || menu.bottomLinks || [];
    return `
      <div class="custom-navigation-menu mobile-menu">
        <div class="nav-mobile">
          ${menu.items.map(item => `
            <div class="menu-item${item.groups.length ? '' : ' no-submenu'}">
              <div class="menu-link">
                <div class="left">
                  <div class="icon"${item.icon ? ` style="background-image: url(${escapeHtml(item.icon)})"` : ''}></div>
                  <div class="menu-name">
                    <a
  href="${escapeHtml(item.href)}"
>
  ${escapeHtml(formatNavTitle(item.title, item.href))}
</a>
                  </div>
                </div>
                <div class="right"></div>
              </div>

              <div class="menu-wrapper">
                ${item.groups.map(group => `
                  <div class="level">
                    ${group.title ? `
                      <div class="title">
                        <div class="titleName">
                          ${group.href
                            ? `<a href="${escapeHtml(group.href)}">${escapeHtml(group.title)}</a>`
                            : `${escapeHtml(group.title)}`
                          }
                        </div>
                        <div class="titleIcon"></div>
                      </div>
                    ` : ''}
                    <div class="level1_box">
                      <div class="level1">
                        ${group.products.map(product => `

                          <div class="item">
                            <a href="${escapeHtml(product.href)}">
                              <div class="product-img product-img-1">
                                ${product.image ? `<img src="${escapeHtml(optimizeImageUrl(product.image, 240))}" alt="${escapeHtml(product.name)}" loading="lazy" decoding="async" fetchpriority="low">` : ''}
                                <div class="tags">
                                  ${product.isNew ? '<span class="tag new"> NEW </span>' : ''}
                                </div>
                              </div>

                              <p class="product-name">
                                <span class="product-name-text">
                                  ${escapeHtml(
                                    product.name === "A50CS"
                                      ? "A50C"
                                      : product.name === "A100CS"
                                      ? "A100C"
                                      : product.name
                                  )}
                                </span>

                                ${
                                  product.name === "A50CS" || product.name === "A100CS"
                                    ? `
                                      <img
                                        src="https://cdn.shopify.com/s/files/1/0870/8469/5851/files/logo.png?v=1782827193"
                                        alt="Special Edition"
                                        class="special-edition-logo"
                                      />
                                    `
                                    : ""
                                }
                              </p>
                            </a>
                          </div>

                        `).join('')}
                      </div>
                    </div>
                  </div>
                `).join('')}
              </div>
            </div>
          `).join('')}
          ${renderMobileTopLinks(topLinks)}
        </div>
      </div>
    `;
  }


  function injectSummerSaleStyles() {
    if (document.getElementById('custom-nav-summer-sale-styles')) return;
    const style = document.createElement('style');
    style.id = 'custom-nav-summer-sale-styles';
    style.textContent = `
      @keyframes buy-now-pay-later-shine {
        0% { transform: translateX(-160%) skewX(-22deg); opacity: 0; }
        12% { opacity: .9; }
        48% { opacity: .9; }
        68%, 100% { transform: translateX(360%) skewX(-22deg); opacity: 0; }
      }
      /* Buy Now Pay Later — red, animated shine on desktop and mobile */
      .desktop-menu a.buy-now-pay-later-nav-link,
      .mobile-menu-top-links a.buy-now-pay-later-nav-link,
      #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link {
        position: relative !important;
        isolation: isolate !important;
        overflow: hidden !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        white-space: nowrap !important;
        border-radius: 999px !important;
        padding: 7px 12px !important;
        margin: 0 4px !important;
        background: linear-gradient(135deg, #b40000 0%, #ed1c24 52%, #b40000 100%) !important;
        background-color: #d60000 !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
        border: 1px solid rgba(255,255,255,.7) !important;
        box-shadow: 0 3px 12px rgba(190,0,0,.28), inset 0 1px 0 rgba(255,255,255,.22) !important;
        font-weight: 800 !important;
        text-decoration: none !important;
        transition: transform .2s ease, box-shadow .2s ease !important;
      }
      .desktop-menu a.buy-now-pay-later-nav-link { padding: 8px 13px !important; }
      .desktop-menu a.buy-now-pay-later-nav-link .nav-link-text,
      .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-label,
      #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-label {
        position: relative !important;
        z-index: 2 !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
      }
      .desktop-menu a.buy-now-pay-later-nav-link::after,
      .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-shine,
      #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-shine {
        content: "" !important;
        position: absolute !important;
        top: -20% !important;
        bottom: -20% !important;
        left: -35% !important;
        width: 28% !important;
        z-index: 1 !important;
        pointer-events: none !important;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,.78), rgba(255,255,255,.18), transparent) !important;
        animation: buy-now-pay-later-shine 2.8s ease-in-out infinite !important;
      }
      .desktop-menu a.buy-now-pay-later-nav-link::before,
      .mobile-menu-top-links a.buy-now-pay-later-nav-link::before,
      #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link::before {
        content: none !important;
        display: none !important;
      }
      .desktop-menu a.buy-now-pay-later-nav-link:hover,
      .mobile-menu-top-links a.buy-now-pay-later-nav-link:hover,
      #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link:hover {
        transform: translateY(-1px) !important;
        box-shadow: 0 5px 16px rgba(190,0,0,.42), inset 0 1px 0 rgba(255,255,255,.28) !important;
      }
      @media (prefers-reduced-motion: reduce) {
        .desktop-menu a.buy-now-pay-later-nav-link::after,
        .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-shine,
        #MenuDrawer .mobile-menu-top-links a.buy-now-pay-later-nav-link .buy-now-pay-later-shine {
          animation: none !important;
          display: none !important;
        }
      }
      @keyframes summer-sale-float-mobile {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-2px); }
      }
      @keyframes summer-bg-marquee {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      @keyframes summer-shimmer-slide {
        0%   { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      @keyframes summer-sun-pulse {
        0%, 100% { transform: rotate(0deg) scale(1); filter: drop-shadow(0 0 3px rgba(255,174,0,.65)); }
        50% { transform: rotate(14deg) scale(1.15); filter: drop-shadow(0 0 7px rgba(255,174,0,.95)); }
      }
      @keyframes independence-star-twinkle {
        0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; filter: drop-shadow(0 0 3px rgba(255,255,255,.7)); }
        50% { transform: scale(1.2) rotate(12deg); opacity: .85; filter: drop-shadow(0 0 7px rgba(255,255,255,.95)); }
      }
      @keyframes independence-bg-marquee {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      @keyframes independence-shimmer-slide {
        0%   { transform: translateX(-120%); opacity: 0; }
        12%  { opacity: 1; }
        88%  { opacity: 1; }
        100% { transform: translateX(320%); opacity: 0; }
      }

      /* Independence Sale (1st highlight) */
      .mobile-menu-top-links a.independence-sale-nav-link,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link {
        position: relative !important;
        isolation: isolate !important;
        overflow: hidden !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 5px !important;
        border-radius: 999px !important;
        padding: 2px 10px 2px 8px !important;
        font-weight: 900 !important;
        font-size: 11.5px !important;
        line-height: 1.35 !important;
        letter-spacing: 0.035em !important;
        text-transform: uppercase !important;
        background: transparent !important;
        background-image: none !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
        border: 1px solid rgba(255,255,255,.55) !important;
        box-shadow: 0 4px 12px rgba(1,65,28,.4), 0 2px 7px rgba(11,122,58,.3), inset 0 -2px 0 rgba(255,255,255,.2) !important;
        animation: summer-sale-float-mobile 2.6s ease-in-out infinite !important;
        transition: transform .2s ease, box-shadow .2s ease !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg {
        position: absolute !important;
        inset: 0 !important;
        overflow: hidden !important;
        border-radius: inherit !important;
        z-index: 0 !important;
        background: #01411c !important;
        pointer-events: none !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg::before,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg::before {
        content: "" !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 200% !important;
        height: 100% !important;
        background: linear-gradient(90deg,
          #01411c 0%,
          #0b7a3a 10%,
          #1a9b4a 18%,
          #9fcfb0 24%,
          #1a9b4a 30%,
          #0b7a3a 40%,
          #01411c 50%,
          #0b7a3a 60%,
          #1a9b4a 68%,
          #9fcfb0 74%,
          #1a9b4a 80%,
          #0b7a3a 90%,
          #01411c 100%
        ) !important;
        animation: independence-bg-marquee 4s linear infinite !important;
        will-change: transform !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg::after,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-bg::after {
        content: "" !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 40% !important;
        height: 100% !important;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,.1), transparent) !important;
        animation: independence-shimmer-slide 4.5s ease-in-out infinite !important;
        pointer-events: none !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-label,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link .independence-sale-pill-label {
        position: relative !important;
        z-index: 2 !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link::before,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link::before,
      .mobile-menu-top-links a.independence-sale-nav-link::after,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link::after {
        content: none !important;
        display: none !important;
      }
      .mobile-menu-top-links a.independence-sale-nav-link:hover,
      #MenuDrawer .mobile-menu-top-links a.independence-sale-nav-link:hover {
        transform: translateY(-1px) scale(1.07) !important;
        box-shadow: 0 6px 16px rgba(1,65,28,.45), 0 5px 14px rgba(11,122,58,.4), inset 0 -2px 0 rgba(255,255,255,.26) !important;
        opacity: 1 !important;
      }

      /* Super Summer Sale (2nd highlight) */
      .mobile-menu-top-links a.summer-sale-nav-link,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link {
        position: relative !important;
        isolation: isolate !important;
        overflow: hidden !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 5px !important;
        border-radius: 999px !important;
        padding: 2px 10px 2px 8px !important;
        font-weight: 900 !important;
        font-size: 11.5px !important;
        line-height: 1.35 !important;
        letter-spacing: 0.035em !important;
        text-transform: uppercase !important;
        background: transparent !important;
        background-image: none !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
        border: 1px solid rgba(255,255,255,.62) !important;
        box-shadow: 0 4px 12px rgba(21,120,238,.35), 0 2px 7px rgba(255,152,0,.28), inset 0 -2px 0 rgba(255,255,255,.22) !important;
        animation: summer-sale-float-mobile 2.6s ease-in-out infinite !important;
        transition: transform .2s ease, box-shadow .2s ease !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg {
        position: absolute !important;
        inset: 0 !important;
        overflow: hidden !important;
        border-radius: inherit !important;
        z-index: 0 !important;
        background: #1578EE !important;
        pointer-events: none !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg::before,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg::before {
        content: "" !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 200% !important;
        height: 100% !important;
        background: linear-gradient(90deg,
          #1578EE 0%,
          #1578EE 15%,
          #7B6EE8 22%,
          #CC8F6E 28%,
          #FFB74D 33%,
          #FFB74D 42%,
          #CC8F6E 47%,
          #7B6EE8 50%,
          #1578EE 55%,
          #1578EE 65%,
          #7B6EE8 72%,
          #CC8F6E 78%,
          #FFB74D 83%,
          #FFB74D 92%,
          #CC8F6E 97%,
          #1578EE 100%
        ) !important;
        animation: summer-bg-marquee 3s linear infinite !important;
        will-change: transform !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg::after,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-bg::after {
        content: "" !important;
        position: absolute !important;
        top: 0 !important;
        left: -50% !important;
        width: 35% !important;
        height: 100% !important;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,.18), transparent) !important;
        animation: summer-shimmer-slide 3s linear infinite !important;
        pointer-events: none !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-label,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link .summer-sale-pill-label {
        position: relative !important;
        z-index: 2 !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link::before,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link::before,
      .mobile-menu-top-links a.summer-sale-nav-link::after,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link::after {
        content: none !important;
        display: none !important;
      }
      .mobile-menu-top-links a.summer-sale-nav-link:hover,
      #MenuDrawer .mobile-menu-top-links a.summer-sale-nav-link:hover {
        transform: translateY(-1px) scale(1.07) !important;
        box-shadow: 0 6px 16px rgba(255,152,0,.38), 0 5px 14px rgba(21,120,238,.38), inset 0 -2px 0 rgba(255,255,255,.26) !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function ensureMobileMarkup() {
    const drawer = document.querySelector('#MenuDrawer');
    if (!drawer) return null;

    let target =
      drawer.querySelector('.js-injected-custom-mobile-menu') ||
      drawer.querySelector('.drawer__inner') ||
      drawer.querySelector('.halo-sidebar-content') ||
      drawer.querySelector('.halo-sidebar-wrapper') ||
      drawer.querySelector('.drawer__content') ||
      drawer;

    let mount = drawer.querySelector('.js-injected-custom-mobile-menu');
    if (!mount) {
      mount = document.createElement('div');
      mount.className = 'js-injected-custom-mobile-menu';
      target.appendChild(mount);
    }
    return mount;
  }

  function renderForMode(force) {
    const mode = getMode();
    if (!force && currentMode === mode) return;
    currentMode = mode;

    const data = getData();
    injectSummerSaleStyles();

    qsa(ROOT_SELECTOR).forEach(root => {
      if (mode === 'desktop') {
        const alreadyRendered = root.querySelector('.navbar-nav.main-categories[data-server-rendered]');
        if (alreadyRendered) {
          alreadyRendered.removeAttribute('data-server-rendered');
        } else {
          root.innerHTML = renderTopNav(data.topNav);
        }
      } else {
        root.innerHTML = '';
      }
    });

    const desktopLayer = ensureBodyLayer(DESKTOP_LAYER_CLASS);
    if (mode === 'desktop') {
      desktopLayer.innerHTML = '';
      desktopOverlayHydrated = false;
    } else {
      desktopLayer.innerHTML = '';
      desktopOverlayHydrated = false;
    }

    const mobileMount = ensureMobileMarkup();
    if (mobileMount) {
      mobileMount.innerHTML = mode === 'mobile' ? renderMobileMenu(data.mobileMenu) : '';
    }

    if (mode === 'desktop') {
      const hydrateDesktopOverlay = () => {
        if (desktopOverlayHydrated || getMode() !== 'desktop') return;
        const currentData = getData();
        const layer = ensureBodyLayer(DESKTOP_LAYER_CLASS);
        layer.innerHTML = renderDesktopOverlay(currentData.mobileMenu.items);
        desktopOverlayHydrated = true;
        setActiveDesktopType(currentData.topNav[0]?.uid || currentData.mobileMenu.items[0]?.uid || '');
        positionDesktopOverlay();
        initDesktopProductScroll();
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(hydrateDesktopOverlay, { timeout: 1200 });
      } else {
        setTimeout(hydrateDesktopOverlay, 500);
      }
    }
  }

  function setActiveDesktopType(uid) {
    if (!uid) return;

    qsa('.navbar-nav.main-categories .nav-item').forEach(item => {
      item.classList.toggle('active', item.dataset.uid === uid);
    });

    qsa('.type-box .type-item').forEach(item => {
      item.classList.toggle('active', item.dataset.uid === uid);
    });

    qsa('.product-box .type1').forEach(panel => {
      const isActive = panel.dataset.uid === uid;
      panel.classList.toggle('active', isActive);
      if (isActive) {
        const cateItems = qsa('.cateNav .cateNavItem', panel);
        const series = qsa('.product-list .product-series', panel);
        cateItems.forEach(item => item.classList.remove('active'));
        const hasAllSeries = series.some(item => item.dataset.id === '__all__');
        series.forEach((item, i) => {
          const activate = hasAllSeries ? item.dataset.id === '__all__' : i === 0;
          item.classList.toggle('active', activate);
        });
      }
    });
    initDesktopProductScroll();
  }

  function setActiveDesktopCategory(categoryEl) {
    const panel = categoryEl.closest('.type1');
    if (!panel) return;
    const id = categoryEl.dataset.id;

    qsa('.cateNav .cateNavItem', panel).forEach(el => {
      el.classList.toggle('active', el === categoryEl);
    });

    qsa('.product-list .product-series', panel).forEach(series => {
      series.classList.toggle('active', series.dataset.id === id);
    });
    initDesktopProductScroll();
  }

  function initDesktopProductScroll() {
    if (getMode() !== 'desktop') return;

    qsa('.product-list .product-series').forEach((series) => {
      const wrapper = series.querySelector('.product-wrapper');
      if (!wrapper) return;

      let scrollContainer = wrapper.parentElement;
      if (!scrollContainer || !scrollContainer.classList.contains('product-list-scroll-container')) {
        scrollContainer = document.createElement('div');
        scrollContainer.className = 'product-list-scroll-container';
        wrapper.parentNode.insertBefore(scrollContainer, wrapper);
        scrollContainer.appendChild(wrapper);
      }

      let arrowDown = scrollContainer.querySelector('.product-list-scroll-arrow');
      if (!arrowDown) {
        arrowDown = document.createElement('button');
        arrowDown.className = 'product-list-scroll-arrow';
        arrowDown.type = 'button';
        arrowDown.setAttribute('aria-label', 'Scroll down');
        arrowDown.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12l7 7 7-7"/></svg>';
        scrollContainer.appendChild(arrowDown);
      }

      let arrowUp = scrollContainer.querySelector('.product-list-scroll-arrow-up');
      if (!arrowUp) {
        arrowUp = document.createElement('button');
        arrowUp.className = 'product-list-scroll-arrow-up';
        arrowUp.type = 'button';
        arrowUp.setAttribute('aria-label', 'Scroll up');
        arrowUp.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
        scrollContainer.appendChild(arrowUp);
      }

      if (!scrollContainer.dataset.scrollBound) {
        scrollContainer.dataset.scrollBound = '1';
        arrowDown.addEventListener('click', () => {
          scrollContainer.scrollBy({ top: 220, behavior: 'smooth' });
        });
        arrowUp.addEventListener('click', () => {
          scrollContainer.scrollBy({ top: -220, behavior: 'smooth' });
        });
      }

      const updateState = () => {
        const isActive = series.classList.contains('active');
        const hasEnoughItems = wrapper.querySelectorAll('.product-item').length > 8;
        const canScroll = scrollContainer.scrollHeight > scrollContainer.clientHeight;
        const atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 10;
        const canScrollUp = scrollContainer.scrollTop > 10;

        scrollContainer.classList.toggle('has-more-rows', isActive && hasEnoughItems && canScroll && !atBottom);
        scrollContainer.classList.toggle('can-scroll-up', isActive && hasEnoughItems && canScroll && canScrollUp);
      };

      if (!scrollContainer.dataset.scrollObserved) {
        scrollContainer.dataset.scrollObserved = '1';
        scrollContainer.addEventListener('scroll', updateState);
      }

      requestAnimationFrame(updateState);
    });
  }

  function positionDesktopOverlay() {
    if (getMode() !== 'desktop') return;
    if (positionDesktopOverlay._raf) return;
    positionDesktopOverlay._raf = requestAnimationFrame(() => {
      positionDesktopOverlay._raf = 0;
      const navContainer = document.querySelector('.js-desktop-menu-overlay .nav-container');
      if (!navContainer || !navContainer.classList.contains('active')) return;
      const header = document.querySelector('.header-section .header, .header-section header');
      if (!header) return;

      const rect = header.getBoundingClientRect();
      navContainer.style.position = 'fixed';
      navContainer.style.left = `${rect.left}px`;
      navContainer.style.top = `${rect.bottom - 10}px`;
      navContainer.style.width = `${rect.width}px`;
      navContainer.style.right = 'auto';
    });
  }

  function bindEvents() {
    function hydrateDesktopOverlayIfNeeded() {
      if (getMode() !== 'desktop' || desktopOverlayHydrated) return;
      const data = getData();
      const desktopLayer = ensureBodyLayer(DESKTOP_LAYER_CLASS);
      desktopLayer.innerHTML = renderDesktopOverlay(data.mobileMenu.items);
      desktopOverlayHydrated = true;
      setActiveDesktopType(data.topNav[0]?.uid || data.mobileMenu.items[0]?.uid || '');
      positionDesktopOverlay();
      initDesktopProductScroll();
    }

    function cancelDesktopClose() {
      if (desktopCloseTimer) {
        clearTimeout(desktopCloseTimer);
        desktopCloseTimer = null;
      }
    }

    function scheduleDesktopClose() {
      cancelDesktopClose();
      desktopCloseTimer = setTimeout(() => {
        if (getMode() !== 'desktop') return;
        const stillInsideNav = !!document.querySelector('.navbar-nav.main-categories:hover');
        const stillInsideContainer = !!document.querySelector('.js-desktop-menu-overlay .nav-container:hover');
        if (stillInsideNav || stillInsideContainer) return;
        forceDesktopClose();
      }, 120);
    }

    function forceDesktopClose() {
      cancelDesktopClose();
      const navContainer = document.querySelector('.js-desktop-menu-overlay .nav-container');
      if (navContainer) navContainer.classList.remove('active');
      qsa('.navbar-nav.main-categories .nav-item').forEach(el => el.classList.remove('active'));
    }

    document.addEventListener('mouseover', (e) => {
      if (getMode() !== 'desktop') return;

      const insideMenu = e.target.closest('.navbar-nav.main-categories, .js-desktop-menu-overlay .nav-container');
      if (insideMenu) {
        cancelDesktopClose();
      }

      hydrateDesktopOverlayIfNeeded();

      const navItem = e.target.closest('.navbar-nav.main-categories .nav-item');
      if (navItem) {
        setActiveDesktopType(navItem.dataset.uid);
        const container = document.querySelector('.js-desktop-menu-overlay .nav-container');
        if (container) container.classList.add('active');
        positionDesktopOverlay();
        initDesktopProductScroll();
        return;
      }

      const typeItem = e.target.closest('.type-box .type-item');
      if (typeItem) {
        setActiveDesktopType(typeItem.dataset.uid);
        return;
      }

      const cateItem = e.target.closest('.cateNav .cateNavItem');
      if (cateItem) {
        setActiveDesktopCategory(cateItem);
      }
    });

    document.addEventListener('mouseout', (e) => {
      if (getMode() !== 'desktop') return;
      const scope = e.target.closest('.navbar-nav.main-categories, .js-desktop-menu-overlay .nav-container');
      if (!scope) return;
      const next = e.relatedTarget;
      if (next && next.closest && next.closest('.navbar-nav.main-categories, .js-desktop-menu-overlay .nav-container')) {
        return;
      }
      scheduleDesktopClose();
    });

    document.addEventListener('mouseleave', () => {
      if (getMode() !== 'desktop') return;
      scheduleDesktopClose();
    });

    document.addEventListener('click', (e) => {
      if (getMode() !== 'mobile') return;

      const right = e.target.closest('#MenuDrawer .nav-mobile .menu-item .menu-link .right');
      if (right) {
        e.preventDefault();
        e.stopPropagation();
        const item = right.closest('.menu-item');
        if (!item || item.classList.contains('no-submenu')) return;

        const isOpen = item.classList.contains('isActive');
        qsa('#MenuDrawer .nav-mobile .menu-item').forEach(other => {
          if (other !== item) other.classList.remove('isActive');
        });
        item.classList.toggle('isActive', !isOpen);
        if (item.classList.contains('isActive')) bumpMobileMenuImages(item);
        return;
      }

      const menuLink = e.target.closest('#MenuDrawer .nav-mobile .menu-item .menu-link');
      if (menuLink) {
        if (e.target.closest('a')) {
          e.stopPropagation();
          return;
        }
        const item = menuLink.closest('.menu-item');
        if (!item || item.classList.contains('no-submenu')) return;

        e.preventDefault();
        e.stopPropagation();
        const isOpen = item.classList.contains('isActive');
        qsa('#MenuDrawer .nav-mobile .menu-item').forEach(other => {
          if (other !== item) other.classList.remove('isActive');
        });
        item.classList.toggle('isActive', !isOpen);
        if (item.classList.contains('isActive')) bumpMobileMenuImages(item);
        return;
      }

      const title = e.target.closest('#MenuDrawer .nav-mobile .menu-wrapper .title');
      if (title) {
        if (e.target.closest('a')) {
          e.stopPropagation();
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const level = title.closest('.level');
        const wrapper = level?.closest('.menu-wrapper');
        if (!level || !wrapper) return;
        const isOpen = level.classList.contains('isAct');
        qsa('.level', wrapper).forEach(other => {
          if (other !== level) other.classList.remove('isAct');
        });
        level.classList.toggle('isAct', !isOpen);
        if (level.classList.contains('isAct')) bumpMobileMenuImages(level);
      }
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => renderForMode(false), 120);
    });

    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const delta = Math.abs(window.scrollY - lastScrollY);
      if (delta > 30) {
        forceDesktopClose();
      }
      lastScrollY = window.scrollY;
      positionDesktopOverlay();
    }, { passive: true });
    window.addEventListener('blur', forceDesktopClose);
  }

  function init() {
    renderForMode(true);
    bindEvents();

    const drawer = document.querySelector('#MenuDrawer');
    if (drawer && window.MutationObserver) {
      let mutationTimer;
      const observer = new MutationObserver(() => {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(() => {
          if (getMode() === 'mobile' && !drawer.querySelector('.js-injected-custom-mobile-menu')) {
            renderForMode(true);
          }
        }, 100);
      });
      observer.observe(drawer, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
